import { isEmpty } from "@utdanningsdirektoratet/utils/string";
import {
  kontonummer as validateKontonummer,
  organisasjonsnummer as validateOrgnr,
  fodselsnummer as validateFodselsnummer,
} from "@utdanningsdirektoratet/utils/validate";
import { ValidationType } from "./types";

export const required: ValidationType<unknown, unknown> = {
  validation: (value) => !isEmpty(value),
  message: "Må fylles ut",
};

export const boolRequired: ValidationType<unknown, unknown> = {
  validation: (value) => !!value && ((value as boolean) === true || (value as string) === "true"),
  message: "Må fylles ut",
};

export const numberRequired: ValidationType<unknown, unknown> = {
  validation: (value) => !!value && /^[0-9]+$/.test(`${value}`.replace(/ /gi, "")),
  message: "Må fylles ut",
};

export const email: ValidationType<unknown, unknown> = {
  validation: (value) => !!value && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value as string),
  message: "Ugyldig e-postadresse",
};

export const organisasjonsnummer: ValidationType<unknown, unknown> = {
  validation: (value) => !!value && validateOrgnr(value as string),
  message: "Ugyldig organisasjonsnummer",
};

export const fodselsnummer: ValidationType<unknown, unknown> = {
  validation: (value) => !!value && validateFodselsnummer(value as string),
  message: "Ugyldig fødselsnummer",
};

export const kontonummer: ValidationType<unknown, unknown> = {
  validation: (value) => !!value && validateKontonummer(value as string),
  message: "Ugyldig kontonummer",
};

export const nonEmptyArray: ValidationType<unknown, unknown> = {
  validation: (value) => !!value && Array.isArray(value) && (value as Array<unknown>).length !== 0,
  message: "Må inneholde et element",
};

export const optional: ValidationType<unknown, unknown> = {
  validation: () => true,
  message: "",
};

export const optionalWhen = (
  validationToWrap: ValidationType<unknown, unknown>,
  optionalReason: boolean | (typeof validationToWrap)["validation"]
): ValidationType<unknown, unknown> => ({
  ...validationToWrap,
  validation: (value, values) =>
    (typeof optionalReason === "function" ? optionalReason(value, values) : optionalReason) || validationToWrap.validation(value, values),
});

export const optionalWhenEmpty = (validationToWrap: ValidationType<unknown, unknown>): ValidationType<unknown, unknown> =>
  optionalWhen(validationToWrap, (value) => !value || (Array.isArray(value) && (value as Array<unknown>).length === 0));

export const requiredIf = (
  validationToWrap: ValidationType<unknown, unknown>,
  requiredReason: boolean | (typeof validationToWrap)["validation"]
): ValidationType<unknown, unknown> =>
  optionalWhen(
    validationToWrap,
    (value, values) => !(typeof requiredReason === "function" ? requiredReason(value, values) : requiredReason)
  );
